import React from "react";
import ReactSelect from "react-select";

const CustomSelect = (props) => {

  const {
    isClearable,
    onChange,
    options,
    optionsLabel,
    optionsId,
    selectedValue,
    placeholder,
    classNames,
    noMessage,
    ...rest
  } = props;
  return (
    <ReactSelect
      isClearable={isClearable}
      onChange={(e) => { onChange && onChange(e)} }
      options={options}
      getOptionLabel={(option) => option[optionsLabel || "name"]}
      value={props.selectedValue}
      getOptionValue={(option) => option[optionsId || "id"]}
      placeholder={placeholder}
      className={classNames}
      classNamePrefix="gl-custom-select"
      noOptionsMessage={() => noMessage || "Sem resultados"}
      {...rest}
    />
  );
};

export default CustomSelect;
